<template>
  <div class="placeholderWrap">
    <img src="@/assets/img/placeholder.png" alt="" />
    <p class="emptyTipe">{{ emptyTipe }}</p>
  </div>
</template>

<script>
export default {
  name: "Placeholder",
  props: {
    emptyTipe: {
      type: String,
      default() {
        return this.$t("common.tableTipe");
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.placeholderWrap {
  padding: 80px 0 40px;
  text-align: center;
}

.emptyTipe {
  margin-top: 12px;
  font-size: 16px;
  color: #909399;
}

.placeholderWrap img {
  width: 100px;
  height: 96px;
}
</style>
